import {NextPage} from 'next';

import {Screen} from '#component/base';
import {ChangePasswordForm} from '#component/form';
import {ChangePasswordValues} from '#component/form/ChangePasswordForm';
import {AuthCTAMessages} from '#component/partial';
import {EventType, useAnalytics, UserActionEvent} from '#component/provider/AnalyticsProvider';
import {withRequireUserState} from '#component/util/RequireUserState/RequireUserState';
import {useToastQueue} from '#hook';
import {sprinkles} from '#style/sprinkles';

import {useChangePassword} from './useChangePassword';

const ChangePasswordScreen = () => {
  const {track} = useAnalytics();
  const {handleSubmitUserPassword} = useChangePassword();
  const {addToast} = useToastQueue();

  const onSubmit = async (formValues: ChangePasswordValues) => {
    await handleSubmitUserPassword(formValues);
    addToast({children: 'Password changed'});
    track<UserActionEvent>({
      evtName: EventType.UserAction,
      actionName: 'Change Password Success',
    });
  };

  return (
    <Screen
      pageName="Change Password"
      sidePanelImageUrl="/image/verify-account.jpg"
      contentContainerClassName={sprinkles({
        flex: 'flex',
        content: ['end', 'end', 'center'],
        dir: 'col',
      })}>
      <div
        className={sprinkles({
          direction: 'col',
          flex: 'flex',
          height: 'full',
          placeContent: ['end', 'center'],
        })}>
        <AuthCTAMessages title="Edit Password?" />

        <ChangePasswordForm onSubmit={onSubmit} />
      </div>
    </Screen>
  );
};

export const ChangePassword: NextPage = withRequireUserState(ChangePasswordScreen, {
  userState: 'authenticated',
});
